﻿namespace eXpress.iframeeditor {
	export interface IIFrameEditorDependencies {
		orderService: services.OrderService;
	}

	export interface IIframeEditorPageContext {
		productCategoryUrl: string;
	}

	export class IFrameEditor {

		private orderService: services.OrderService;
		private context: core.IAppContext;
		private pvc: string;
		private pageContext: IIframeEditorPageContext;
		private header: JQuery;

		constructor(deps: IIFrameEditorDependencies, context: core.IAppContext, pageContext: IIframeEditorPageContext) {
			this.context = context;
			this.pageContext = pageContext;
			this.pvc = eXpress.utils.getQueryStringParameter("pvc", undefined, true).toLowerCase();
			this.orderService = deps.orderService;
			const oldHeader = $('.editor-header');
			this.header = oldHeader.length > 0 ? oldHeader : $('.o-small-header');
		}

		public start(): void {
			this.orderService.getPriceAsync(this.pvc, 1, 0, undefined, undefined).then(res => {
				const $price = this.header.find('.technical-price').show().find('.technical-amount');
				$price.html(utils.displayPrice(res.price.amount, true, false, this.context));
			});
			this.header.find('.technical-back-to').attr('href', this.pageContext.productCategoryUrl).show().parent('.u-hide').removeClass("u-hide");
		}
	}

	const deps = {
		orderService: new eXpress.services.OrderService(core.context)
	};

	const app = new IFrameEditor(deps, eXpress.core.context, pageContext);
	app.start();
}
